var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Generic error class for API responses where the format was incorrect.
 *
 * @category Response
 */
var DataError = /** @class */ (function (_super) {
    __extends(DataError, _super);
    /**
     * Constructor.
     */
    function DataError(message, response) {
        var _this = _super.call(this, message) || this;
        _this.response = response;
        // Check if the browser allows setting prototype, otherwise manually set it
        // We need to set the prototype to make sure "instanceof DataError" checks are working
        if (Object.setPrototypeOf) {
            Object.setPrototypeOf(_this, DataError.prototype);
        }
        else {
            _this["__proto__"] = DataError.prototype;
        }
        return _this;
    }
    return DataError;
}(Error));
export { DataError };
